var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/icon.tsx";
const _excluded = ["src"],
      _excluded2 = ["id", "fixedWidth"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Icon: abstract icon class that can render icons from multiple sets.
 * @module soapbox/components/icon
 * @see soapbox/components/fork_awesome_icon
 * @see soapbox/components/svg_icon
 */
import React from 'react';
import ForkAwesomeIcon from './fork-awesome-icon';
import SvgIcon from './svg-icon';

const Icon = props => {
  if (props.src) {
    const _ref = props,
          {
      src
    } = _ref,
          rest = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/React.createElement(SvgIcon, _extends({
      src: src
    }, rest, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 12
      }
    }));
  } else {
    const _ref2 = props,
          {
      id,
      fixedWidth
    } = _ref2,
          rest = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/React.createElement(ForkAwesomeIcon, _extends({
      id: id,
      fixedWidth: fixedWidth
    }, rest, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23,
        columnNumber: 12
      }
    }));
  }
};

export default Icon;